import _ from 'lodash';
import AppConstatnt from '../../../../config/app.constants';

class BagoutsController {
  /*@ngInject*/
  constructor(Auth, $state, User, UserService, RouteService, $translate, LocationService, ScanService, $location,
    $q, Modal, ShipmentService, BranchService, BagoutService, SetupService, DateUtil, HoldService, Navigation, $rootScope) {
    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.RouteService = RouteService;
    this.LocationService = LocationService;
    this.BranchService = BranchService;
    this.ScanService = ScanService;
    this.$q = $q;
    this.Modal = Modal;
    this.ShipmentService = ShipmentService;
    this.BagoutService = BagoutService;
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.HoldService = HoldService;
    this.Navigation = Navigation;
    this.$rootScope = $rootScope;

    this.model = {
      bagout: null,
      test: null,
      branch: this.User.getUser().branchId,
      search: null,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      // date range picker for bagout tab
      dateRangPickerOptions: {},
      bagoutObj: {
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        },
        results: [],
        totalRecords: 0
      },
      loggedInUserId: this.User.getUser().id
    }

    // this.showDt = moment().diff(moment(this.model.dateRange.startDate)) > 3024018327 ? true : false;
    this.valutDate = "";
    this.routes = [];
    this.branches = [];
    this.bagsealData = [];
    this.allbagseal = [];
    this.shipmentData = [];
    this.isError = false;
    this.msg = '';
    this.isShipmentDelivered = false;
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/bagouts-history');
  }

  // openPicker() {
  //   this.showDt = moment().diff(moment(this.model.dateRange.startDate)) > 633830668646 ? true : false;
  //   setTimeout(function () { angular.element('#dtpc').trigger('click'); }, 200);
  // }

  $onInit() {
    this.$q.all([
      this.SetupService.get(this.User.getUser().branchId)
    ])
      .then((data) => {
        this.valutDate = this.DateUtil.convertToDate(data[0].currentVaultDate);
        this.setDateRange(this.valutDate);
        this.model.dateRange.startDate = moment(this.valutDate).startOf('day').format('YYYY-MM-DD');
        this.model.dateRange.endDate = moment(this.valutDate).endOf('day').format('YYYY-MM-DD');
        this.holdRouteId = data[0].holdRouteId;
      })
      .then(() => {
        this.loadPermission();
        this.getBagSealData('', 0);
      })
      .catch((err) => {
        console.log(err);
      });

    this.model.noItemDisplayed = this.$translate.instant('error.branch_mgmt.location');
    this.model.noItems = true;
    this.model.dateRange;
  }

  loadPermission() {
    this.acl = {};
    this.hasACL = {};

    [].forEach((permissionKey) => {
      this.acl[permissionKey] = this.User.getACL(permissionKey)

      this.hasACL[permissionKey] = {};

      this.acl[permissionKey].forEach((permission) => {
        this.hasACL[permissionKey][permission] = true;
      });
    });
  }

  getBagSealData(searchKey, offset) {
    searchKey = searchKey || null;

    const startDate = this.getStartDate();
    const endDate = this.getEndDate();

    this.model.bagoutObj.loading = true;
    this.BagoutService.fetchBagSeals(searchKey, startDate, endDate, this.model.bagoutObj.pagination.pageLimit, offset)
      .then((data) => {
        if (offset === 0 || offset == undefined) {
          this.model.bagoutObj.results = this.mapData(data.results);
          this.model.bagoutObj.totalRecords = data.total;
        } else {
          const bagouts = this.mapData(data.results);
          this.model.bagoutObj.results = this.model.bagoutObj.results.concat(bagouts);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.model.bagoutObj.loading = false;
      })
  }

  mapData(arrayObj) {
    return arrayObj.map((obj) => {
      return {
        Key: obj.bagSeal + ' | (' + (obj.closedDate ? moment.utc(obj.closedDate).format('YYYY-MM-DD') : 'Open') + ') | ' + obj.toLocationId,
        Value: obj.bagSeal
      }
    });
  }

  setDateRange(date) {
    let currentVaultDate = moment(date).format() || moment();
    this.model.dateRangPickerOptions = {
      autoApply: true,
      opens: "left",
      // drops: "auto",
      maxDate: moment(currentVaultDate),
      eventHandlers: {
        'apply.daterangepicker': () => {
          this.onDateChanged();
        }
      },
      ranges: {
        'Today': [
          moment(currentVaultDate).startOf('day').format('YYYY-MM-DD'),
          moment(currentVaultDate).endOf('day').format('YYYY-MM-DD')
        ],
        'Last 5 Vault Date': [
          moment(currentVaultDate).subtract(4, 'day').format('YYYY-MM-DD'),
          moment(currentVaultDate).endOf('day').format('YYYY-MM-DD')
        ],
        'Last 7 Vault Date': [
          moment(currentVaultDate).subtract(6, 'day').format('YYYY-MM-DD'),
          moment(currentVaultDate).endOf('day').format('YYYY-MM-DD')
        ],
        'Last 10 Vault Date': [
          moment(currentVaultDate).subtract(9, 'day').format('YYYY-MM-DD'),
          moment(currentVaultDate).endOf('day').format('YYYY-MM-DD')
        ],
      }
    }
  }

  onDateChanged() {
    this.model.bagout = null;
    this.shipmentData = [];
    this.model.noItems = true;
    this.model.noItemDisplayed = this.$translate.instant('error.branch_mgmt.location');
    this.getBagSealData('', 0);
  }

  // Get data of bagout
  loadDataOfBagoutHistory(date) {
    this.msg = '';
    // this.showDt = moment().diff(moment(this.model.dateRange.startDate)) > 633830668646 ? true : false;
    // this.startDate = moment(this.model.dateRange.startDate).format('YYYY-MM-DD HH:mm:ss');
    // this.endDate = moment(this.model.dateRange.endDate).format('YYYY-MM-DD HH:mm:ss');

    if (this.model.bagout === "" || this.model.bagout == null) {
      this.model.noItems = true;
      delete this.model.noDataFound
      this.model.noItemDisplayed = this.$translate.instant('error.branch_mgmt.location');
      this.shipmentData = [];
      return;
    }

    this.loading = true;
    this.$q.all([
      this.BagoutService.getBagsealData(this.model.bagout.Value),
      this.ShipmentService.getShipmentTrakingDetail(this.model.bagout.Value)
    ])
      .then((res) => {
        this.loading = false;
        this.shipmentData = res[0].shipment;
        this.bagOutData = res[0].bagout;
        this.bagoutShipmentDetails = res[1][0] || [];
        // if (res[1] && res[1].length) {
        //   this.isShipmentDelivered = res[1][0].deliveredFlag;
        // }

        this.isShipmentDelivered = res[1] && res[1].length ? res[1][0].deliveredFlag : undefined;

        if (this.bagOutData.closed) {
          this.bagOutClosed = this.$translate.instant('bagout.status_closed');
          this.closedDate = moment.utc(this.bagOutData.closedDate).format('YYYY-MM-DD');
        }
        else {
          this.bagOutClosed = this.$translate.instant('bagout.status_notclosed');
          this.createdAt = moment.utc(this.bagOutData.createdAt).format('YYYY-MM-DD hh:mm:ss A')
          this.updatedAt = moment.utc(this.bagOutData.updatedAt).format('YYYY-MM-DD hh:mm:ss A')
        }

        if (this.shipmentData.length) {
          delete this.model.noItemDisplayed;
          this.model.noItems = false;
          this.localDateTime = moment(this.valutDate).format('MM-DD-YYYY');
        }
        else {
          delete this.model.noItemDisplayed;
          this.model.noItems = false;
          this.model.noDataFound = this.$translate.instant('error.branch_mgmt.bagout_not_found');
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      })
  }

  // undo all bagout
  undoBagouts(allowOnce) {
    this.allowOnce = allowOnce;
    this.BagoutService.undoBagout(this.model.bagout.Value, this.bagOutData.branchId)
      .then((data) => {
        this.allowOnce = false;
        this.model.bagout = null;
        this.shipmentData = [];
        this.model.noItems = true;
        delete this.model.noDataFound;
        this.model.noItemDisplayed = this.$translate.instant('error.branch_mgmt.location');
        this.getBagSealData('', 0);
      })
      .catch((err) => {
        this.allowOnce = false;
        if (err && err.data && err.data.message) {
          return this.Modal.errorModal('error.' + err.data.message)
        }
      })
  }

  confirmUndoBagouts() {
    if (this.allowOnce) return;
    this.allowOnce = true;
    this.Modal.confirmSupervisor('undo-bagouts', null, ({ modal, supId }) => {
      modal.close();
      setTimeout(() => {
        this.allowOnce = false;
      }, 1000)
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('bagout.delete_message'),
        callback: (({
          modal,
          $scope
        }) => {
          this.allowOnce = true;
          this.undoBagouts(this.allowOnce);
          modal.close();
        }),
        type: 'danger'
      })
    }, ({ modal }) => {
      this.allowOnce = false;
      modal.close();
    });
  }

  markAsDelivered() {
    if (this.allowOnlyOnce) return;
    this.allowOnlyOnce = true;
    this.Modal.confirmSupervisor('mark-delivered', null, ({ modal, supId }) => {
      modal.close();
      this.HoldService.markToDelivered(supId, this.model.bagout.Value)
        .then((response) => {
          this.isError = false;
          this.allowOnlyOnce = false;
          this.msg = this.$translate.instant('branch_mgmt.bagout.delivery_success');
          this.isShipmentDelivered = true;
        })
        .catch((err) => {
          this.isError = true;
          this.allowOnlyOnce = false;
          if (err && err.data && err.data.message) {
            this.msg = this.$translate.instant('error.' + err.data.message);
          }
          // else {
          //   this.msg = this.$translate.instant('branch_mgmt.bagout.error_delivery');
          // }
        });

    }, ({ modal }) => {
      this.allowOnlyOnce = false;
      modal.close();
    });
  }

  getStartDate() {
    return this.model.dateRange.startDate ? moment(this.model.dateRange.startDate).format('YYYY-MM-DD') : null;
  }

  getEndDate() {
    return this.model.dateRange.endDate ? moment(this.model.dateRange.endDate).format('YYYY-MM-DD') : null;
  }

  goToServiceHistory(locationId) {
    return this.Navigation.goToServiceHistory(locationId, null, true, null);
  }

  goToItemHistory(trackingId) {
    this.Navigation.goToItemHistory(trackingId, null);
  }

  print() {
    let totalAmount = 0;
    let url = this.$state.href('branchMgmtBagoutPrint');

    this.shipmentData.forEach(s => totalAmount += s.amount);

    window.w = window.open(url, '_blank');
    window.w.printData = {
      results: this.shipmentData,
      fromLocationName: this.bagoutShipmentDetails.fromLocation.name,
      fromLocationAddress: this.bagoutShipmentDetails.fromLocation.address,
      toLocationName: this.bagoutShipmentDetails.toLocation.name,
      toLocationAddress: this.bagoutShipmentDetails.toLocation.address,
      bagSealId: this.bagoutShipmentDetails.trackingId,
      routeId: this.bagoutShipmentDetails.route.id,
      routeName: this.bagoutShipmentDetails.route.name,
      totalBags: this.shipmentData.length,
      totalAmount,
      vaultDate: this.bagoutShipmentDetails.vaultDate,
    }
  }

  closebag() {
    const obj = {
      deliveryDate: this.valutDate,
      locationId: this.bagOutData.locationId,
      branchId: this.model.branch,
      bagoutId: this.model.bagout.Value,
      holdRouteId: this.holdRouteId
    };

    this.Modal.branchMgmtBagoutClose(obj, ({ modal, routeId, deliveryDate, $scope }) => {
      $scope.loading = true;
      if (routeId == this.holdRouteId) {
        modal.close();
        this.putOnHold(true, routeId, deliveryDate);
      } else {
        this._closeBagout(routeId, deliveryDate)
          .then((res) => {
            if (res.data && res.data.closed) {
              modal.close();
            }
          }).catch((err) => {
            modal.close();
            if (err && err.data && err.data.message) {
              this.Modal.errorModal('error.' + err.data.message)
            }
          })
          .finally(() => {
            $scope.loading = false;
            this.loadDataOfBagoutHistory();
          })
      }
    }, ({ modal }) => {
      if (modal) modal.close();
    });
  }

  _closeBagout(routeId, deliveryDate) {
    const bagoutDetails = this.bagoutShipmentDetails;
    const shipmentData = [];

    this.shipmentData.forEach((s) => {
      shipmentData.push({
        trackingId: s.trackingId,
        amount: s.amount,
        denominationId: s.denominationId,
        locationId: s.fromLocationId,
        locationName: s.fromLocationName,
      })
    })

    return this.BagoutService.closeBagout(
      this.model.bagout.Value,
      this.model.branch,
      routeId,
      moment(deliveryDate).format('YYYY-MM-DD'),
      bagoutDetails.carrierId ? bagoutDetails.carrier.id : null,
      bagoutDetails.carrierId ? bagoutDetails.carrier.name : null,
      this.model.loggedInUserId,
      shipmentData
    )
  }

  putOnHold(closeBagout, routeId, deliveryDate, $scope) {
    this.Modal.confirmSupervisor('verify-hold', null, ({ modal, supId }) => {
      let allPromise = [];

      if (closeBagout) allPromise.push(this._closeBagout(routeId, deliveryDate));

      this.$q.all(allPromise)
        .then(() => {
          this.ShipmentService.holdShipment(
            this.model.branch,
            this.model.bagout.Value,
            routeId,
            moment(deliveryDate).format('YYYY-MM-DD'),
            supId,
            '',
            ''
          ).then(() => modal.close())
            .catch((err) => {
              modal.close();
              if (err && err.data && err.data.message) {
                this.Modal.errorModal('error.' + err.data.message)
              }
            })
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            if (modal) modal.close();
            return this.Modal.errorModal('error.' + err.data.message);
          }
        })
        .finally(() => {
            this.loadDataOfBagoutHistory();
        })
    }, ({ modal }) => {
      modal.close();
    });
  }

  removeTrackingIdFromBagout(shipment) {
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('bagout.remove_tracking-id-message'),
      callback: (({
        modal,
        $scope
      }) => {
        this.BagoutService.removeTrackingIdFromBagout(shipment.trackingId, this.model.branch, this.model.bagout.Value, shipment.fromLocationId, this.bagOutData.locationId, shipment.vaultDate)
          .then(() => { this.loadDataOfBagoutHistory(); })
          .catch(() => {
            if (err && err.data && err.data.message) {
              return this.Modal.errorModal('error.' + err.data.message)
            }
          })
        modal.close();
      }),
      type: 'danger'
    })
  }
}
export default BagoutsController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/bagouts/bagouts.controller.js